import { render, staticRenderFns } from "./ConjuntsDades.vue?vue&type=template&id=2e810caf&"
import script from "./ConjuntsDades.vue?vue&type=script&lang=js&"
export * from "./ConjuntsDades.vue?vue&type=script&lang=js&"
import style0 from "./ConjuntsDades.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports